import DocumentRetryRequestModal from './DocumentRetryRequestModal';

export default DocumentRetryRequestModal;
